import Constants from 'expo-constants';

export const revokeAppAccess = async (accessToken: string) => {
  const { loginBaseUrl, loginClientId } = Constants.expoConfig?.extra || {};

  const result = await fetch(`${loginBaseUrl}/user/apps/revoke`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ client_id: loginClientId }),
  });

  return result;
};
